import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForceSyncService {
  private readonly subject = new BehaviorSubject(false);
  forceSync$ = this.subject.asObservable();

  setForceSync(value: boolean) {
    this.subject.next(value);
  }
}
